module.exports = __webpack_public_path__ + "images/home3.webp";